import { render, staticRenderFns } from "./PhoneVerify.vue?vue&type=template&id=51ced21e&scoped=true&"
import script from "./PhoneVerify.vue?vue&type=script&lang=js&"
export * from "./PhoneVerify.vue?vue&type=script&lang=js&"
import style0 from "../../less/login.less?vue&type=style&index=0&id=51ced21e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ced21e",
  null
  
)

export default component.exports